import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  User,
  onAuthStateChanged,
} from "firebase/auth";

export const getCurrentUser = (): Object => {
  return getAuth().currentUser ?? {};
};

export const handleLoginExpiration = (setUser: (user: User | {}) => void) => {
  const auth = getAuth();

  // Set up listener for auth state changes
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    // Call setUser on every user change (user will be null when logged out)
    setUser(user || {});
  });

  // Return unsubscribe function so caller can clean up the listener
  return unsubscribe;
};

export const initiateGoogleLogin = async (): Promise<User | {}> => {
  const auth = getAuth();
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    return user;
  } catch (error) {
    // Handle Errors here.
    console.warn({ error });
    return {};
  }
};

export const handleLogout = async () => {
  try {
    const auth = getAuth();
    await signOut(auth);
  } catch (e) {
    console.warn(e);
  }
};
